import pdf from './img/pdf.png'
import word from './img/word.png'
import excel from './img/excel.png'
import { MY_CONSTANTS } from '@/util/constants'
export const useGetImg = () => {
  const getImg = (type) => {
    if (type === 'pdf') {
      return pdf
    } else if (type === 'doc' || type === 'docx') {
      return word
    } else if (type === 'xls' || type === 'xlsx') {
      return excel
    }
  }

  const showUrl = (url) => {
    return MY_CONSTANTS.$imgurl + url
  }
  return { getImg, showUrl }
}